import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OrderUnlockComponent } from '@app/features';
import { NgxFileDropModule } from 'ngx-file-drop';
import { NgxUiLoaderConfig, NgxUiLoaderHttpModule, NgxUiLoaderModule, SPINNER } from 'ngx-ui-loader';



import { ErrorInterceptor, JwtInterceptor } from './_helpers';
import { AlertComponent } from './alert/alert.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { VolantiniService } from './_services/volantini.service';
import { CommonModule } from '@angular/common';




// Angular Material
// Custom Components
const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  fgsColor: '#673ab7',
  fgsType: SPINNER.ballSpinClockwiseFadeRotating,
  hasProgressBar: false,
  overlayColor: 'rgba(73, 70, 70, .5)',
  fgsPosition: 'center-center'
};


@NgModule({
  declarations: [
    AppComponent,
    OrderUnlockComponent,
    HomeComponent,

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NgxFileDropModule,
    BrowserAnimationsModule,
    MatTableModule,
  
    

    //Loader
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxUiLoaderHttpModule.forRoot({
      showForeground: true,
      excludeRegexp: [
        // Escludi polling status dei background task (regex per matchare qualsiasi numero)
        'B2C/BackgroundTask/Status/\\d+$',
        'B2C/PushNotification/TaskStatus/\\d+$'
      ]
    }),

    FormsModule,
    ReactiveFormsModule, //added specifically to support dynamic form used in login (for now)

    MatButtonModule,
    MatTabsModule,
    MatTableModule,
    MatSelectModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatInputModule,
    MatNativeDateModule,
    MatToolbarModule,
    MatSidenavModule,
    MatListModule,
    MatIconModule,
    MatCardModule,
    MatPaginatorModule,
    MatChipsModule,
    MatSortModule,
    CommonModule,

    // Standalone components
    AlertComponent,

  ],
  providers: [
    MatNativeDateModule,
    { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    VolantiniService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
